import React from "react";
import { RadioButton } from "material-ui/RadioButton";

export default class CustomRadioButton extends React.PureComponent {
    render() {
        const {
            checkedIcon = {},
            uncheckedIcon = {},
            disabled = false,
            iconStyle = { fill: "#1D7CBF" },
            inputStyle = {},
            labelStyle = {},
            value = "",
            style = {}
        } = this.props;
        return (
            <RadioButton
                {...this.props}
                checkedIcon={checkedIcon}
                uncheckedIcon={uncheckedIcon}
                value={value}
                iconStyle={Object.assign({}, iconStyle)}
                inputStyle={Object.assign({}, inputStyle)}
                labelStyle={Object.assign({}, labelStyle)}
                disabled={disabled}
                style={Object.assign({}, style)}
            />
        );
    }
}
